
import WkUserSelect from '@/components/NewCom/WkUserSelect';
import WkDepSelect from '@/components/NewCom/WkDepSelect';
import WkPosition from '@/components/NewCom/WkPosition';
import WkLocation from '@/components/NewCom/WkLocation';
import WkSignaturePad from '@/components/NewCom/WkSignaturePad';
import WkDescText from '@/components/NewCom/WkDescText';
import WkPercentInput from '@/components/NewCom/WkPercentInput';
import WkSelect from '@/components/NewCom/WkSelect';
import WkCheckbox from '@/components/NewCom/WkCheckbox';
import WkDetailTable from '@/components/NewCom/WkDetailTable';
import VDistpicker from '@/components/VDistpicker';
import { XhFiles } from '@/components/CreateCom';

import Mixin from './Mixin';

export default {
  // 字段
  name: 'WkField',

  components: {
    WkUserSelect: WkUserSelect,
    WkDepSelect: WkDepSelect,
    WkPosition: WkPosition,
    WkLocation: WkLocation,
    WkSignaturePad: WkSignaturePad,
    WkDescText: WkDescText,
    WkPercentInput: WkPercentInput,
    WkSelect: WkSelect,
    WkCheckbox: WkCheckbox,
    WkDetailTable: WkDetailTable,
    VDistpicker: VDistpicker,
    XhFiles: XhFiles
  },

  mixins: [Mixin],

  props: {
    item: Object,
    index: Number,
    fieldFrom: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 忽略的字段直接输出
    ignoreFields: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: Boolean
  },

  data: function data() {
    return {};
  },


  computed: {},

  watch: {},

  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {}
};